import Container from '@mui/material/Container'

import Heading from '~/client/components/Heading'

export default function AboutPage() {
  return <Container>
    <Heading my={4} variant="major">Help</Heading>
    <p>FAQs and Customer Support Options to Follow.</p>
  </Container>
}
